import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { EndorseBranchOfficeRoutingModule } from "./endorse-branch-office-routing.module";
import { GlobalModule } from "../global/global.module";
import {EndorseBranchOfficeComponent} from "./endorse-branch-office.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    EndorseBranchOfficeRoutingModule,
    GlobalModule,
  ],
  declarations: [
    EndorseBranchOfficeComponent
  ],
  providers: [
    DatePipe
  ]
})
export class EndorseBranchOfficeModule {
}
